const types = {
	simple: 'simple',
	custom: 'custom'
};

const locale = {
	ru: types,
	uk: types,
	en: types,
	de: types,
	vi: types,
	th: types
};

module.exports = {
	enum: types,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/banner-types.js